import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Tooltip } from '@mui/material';

export type StatCardProps = {
    title: string;
    value: string;
    interval: string;
    trend: number | null;
    trendColorReversed: boolean;
    data: number[];
    child: any;
    isBlury: boolean;
    blurTooltip: string;
};

const getRGBColor = (percentage: number, reverse: boolean = false) => {
    if (percentage < 0 || percentage > 100) {
        return 'rgb(255, 255, 255)';
    }

    let red, green;

    if (reverse) {
        red = Math.min(255, Math.max(0, Math.floor(((100 - percentage) / 100) * 255)));
        green = Math.min(255, Math.max(0, Math.floor((percentage / 100) * 255)));
    } else {
        red = Math.min(255, Math.max(0, Math.floor((percentage / 100) * 255)));
        green = Math.min(255, Math.max(0, Math.floor(((100 - percentage) / 100) * 255)));
    }

    return `rgb(${red}, ${green}, 0, 0.2)`;
};


export default function StatCard({
    title,
    value,
    interval,
    trend = null,
    trendColorReversed,
    child,
    isBlury,
    blurTooltip
}: StatCardProps) {
    return (
        <Card variant="outlined" sx={{ height: '100%', flexGrow: 1, width: '100%' }}>
            <Tooltip title={isBlury ? blurTooltip : ''}>
                <CardContent sx={{ filter: isBlury ? 'blur(4px)' : 'none' }}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        {title}
                    </Typography>
                    <Stack
                        direction="column"
                        sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}
                    >
                        <Stack sx={{ justifyContent: 'space-between' }}>
                            <Stack
                                direction="row"
                                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <Typography variant="h4" component="p">
                                    {value}
                                </Typography>
                                {trend != null && <Chip size="small" sx={{ backgroundColor: getRGBColor(trend, trendColorReversed) }} label={`${Math.round(trend)}%`} />}
                            </Stack>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                {interval}
                            </Typography>
                            {child}
                        </Stack>
                    </Stack>
                </CardContent>
            </Tooltip>
        </Card>
    );
}